var Be = Object.defineProperty;
var ge = (t, e, i) => e in t ? Be(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var y = (t, e, i) => (ge(t, typeof e != "symbol" ? e + "" : e, i), i);
let se = !1;
function W(t) {
  se = t;
}
const U = (t) => (...e) => {
  se && console[t](...e);
}, h = {
  error: U("error"),
  warn: U("warn"),
  log: U("log")
}, Re = /* @__PURE__ */ new Set([
  "Symbol",
  "Text",
  "Integer",
  "Number",
  "Boolean",
  "Date",
  "Location",
  "Object"
]);
function G({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: i
}) {
  var s;
  t[i] = ((s = e.fields) == null ? void 0 : s[i]) ?? null;
}
function re(t) {
  var e;
  return !!(Re.has(t.type) || t.type === "Array" && ((e = t.items) == null ? void 0 : e.type) === "Symbol");
}
const we = "2.8.0", A = "Asset";
var L = /* @__PURE__ */ ((t) => (t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.LOCALE = "data-contentful-locale", t))(L || {});
function B(t) {
  return !!(t && typeof t == "object" && "sys" in t && t.sys.id);
}
const q = `current-${L.FIELD_ID}`, z = `current-${L.ENTRY_ID}`, F = `current-${L.LOCALE}`, X = "contentful-tooltip", Ke = 32, Ue = 5, g = 10, ve = "live-preview-editor", Me = "live-preview-sdk";
function N(t, e) {
  var s;
  const i = {
    ...e,
    method: t,
    from: "live-preview",
    source: Me,
    location: window.location.href,
    version: we
  };
  h.log("Send message", i), (s = window.top) == null || s.postMessage(
    i,
    "*"
  );
}
function at(t, e = 100) {
  let i;
  return (...s) => {
    clearTimeout(i), i = setTimeout(() => {
      t.apply(this, s);
    }, e);
  };
}
class me {
  constructor(e, i) {
    y(this, "storageKey");
    y(this, "value");
    this.storageKey = e, this.value = this.restoreSessionData() || i;
  }
  getKey(e, i) {
    return `${e}-${i}`;
  }
  restoreSessionData() {
    try {
      const e = window.sessionStorage.getItem(this.storageKey), i = e ? JSON.parse(e) : null;
      return Array.isArray(i) ? new Map(i) : null;
    } catch {
      return null;
    }
  }
  get(e, i) {
    return this.value.get(this.getKey(e, i));
  }
  set(e, i, s) {
    this.value.set(this.getKey(e, i), s);
    try {
      window.sessionStorage.setItem(
        this.storageKey,
        JSON.stringify(Array.from(this.value.entries()))
      );
    } catch {
      h.warn(`StorageMap: Failed to set data for key "${e}" in sessionStorage`);
    }
  }
  clear() {
    this.value.clear();
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch {
      h.warn("StorageMap: Failed to clear data from sessionStorage");
    }
  }
}
function He(t) {
  if (!t)
    return t;
  try {
    const e = new URL(t, "https://images.ctfassets.net");
    return e.protocol = "https:", e.href;
  } catch (e) {
    return h.error(`Recevied invalid asset url "${t}"`, e), t;
  }
}
function k(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (e) {
    return h.warn("Failed to clone data, updates are done on the original one", t, e), t;
  }
}
function Ge() {
  var t;
  try {
    return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function ke() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function Pe(t, e = 500) {
  let i = window.location.href;
  const n = setInterval(() => {
    const r = window.location.href;
    r !== i && (i = r, t(r));
  }, e);
  return () => clearInterval(n);
}
function ae(t, e) {
  if (!e.length)
    return t;
  try {
    const [i, ...s] = e;
    return ae(t[i], s);
  } catch {
    return;
  }
}
function J(t, e, i) {
  return e in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
class Ye {
  get entities() {
    return [
      ...this.entitiesMap.values()
    ];
  }
  updateEntity(e) {
    this.entitiesMap.set(e.sys.id, e);
  }
  getValue(e, i) {
    const s = this.entitiesMap.get(e.sys.id);
    if (!s || s.sys.type !== e.sys.linkType) {
      console.warn(`Unresolved entity reference: ${e}`);
      return;
    }
    return ae(s, i);
  }
  getEntitiesFromMap(e) {
    const i = [], s = [];
    for (const n of e) {
      const r = this.entitiesMap.get(n);
      r ? i.push(r) : s.push(n);
    }
    if (s.length)
      throw new Error(`Missing entity in the store (${s.join(",")})`);
    return i;
  }
  async fetchAsset(e) {
    try {
      return this.getEntitiesFromMap([
        e
      ])[0];
    } catch {
      console.warn(`Asset "${e}" is not in the store`);
      return;
    }
  }
  async fetchAssets(e) {
    return this.getEntitiesFromMap(e);
  }
  async fetchEntry(e) {
    try {
      return this.getEntitiesFromMap([
        e
      ])[0];
    } catch {
      console.warn(`Entry "${e}" is not in the store`);
      return;
    }
  }
  async fetchEntries(e) {
    return this.getEntitiesFromMap(e);
  }
  constructor({ entities: e, locale: i }) {
    J(this, "locale", void 0), J(this, "entitiesMap", void 0), this.entitiesMap = new Map(e.map((s) => [
      s.sys.id,
      s
    ])), this.locale = i;
  }
}
function C(t, e, i) {
  return e in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
var R;
(function(t) {
  t.REQUEST_ENTITIES = "REQUEST_ENTITIES", t.REQUESTED_ENTITIES = "REQUESTED_ENTITIES";
})(R || (R = {}));
class je extends Ye {
  cleanupPromise(e) {
    setTimeout(() => {
      this.requestCache.delete(e);
    }, 300);
  }
  getCacheId(e) {
    return e.length === 1 ? e[0] : e.join(this.cacheIdSeperator);
  }
  findMissingEntites(e) {
    const i = [];
    for (const s of e)
      this.entitiesMap.get(s) || i.push(s);
    return i;
  }
  async fetchEntity(e, i) {
    const s = this.findMissingEntites(e);
    if (s.length === 0)
      return e.map((l) => this.entitiesMap.get(l));
    const n = this.getCacheId(s), r = this.requestCache.get(n);
    if (r)
      return r;
    const o = new Promise((l, c) => {
      const u = this.subscribe(R.REQUESTED_ENTITIES, (d) => {
        s.every((E) => d.entities.find((T) => T.sys.id === E)) && (clearTimeout(f), l(d.entities), this.cleanupPromise(n), e.forEach((E) => this.cleanupPromise(E)), u());
      }), f = setTimeout(() => {
        c(new Error("Request for entities timed out")), u();
      }, this.timeoutDuration);
      this.sendMessage(R.REQUEST_ENTITIES, {
        entityIds: s,
        entityType: i ? "Asset" : "Entry",
        locale: this.locale
      });
    });
    return this.requestCache.set(n, o), e.forEach((l) => {
      this.requestCache.set(l, o);
    }), (await o).forEach((l) => {
      this.entitiesMap.set(l.sys.id, l);
    }), e.map((l) => this.entitiesMap.get(l));
  }
  async fetchAsset(e) {
    try {
      return (await this.fetchAssets([
        e
      ]))[0];
    } catch {
      console.warn(`Failed to request asset ${e}`);
      return;
    }
  }
  fetchAssets(e) {
    return this.fetchEntity(e, !0);
  }
  async fetchEntry(e) {
    try {
      return (await this.fetchEntries([
        e
      ]))[0];
    } catch (i) {
      console.warn(`Failed to request entry ${e}`, i);
      return;
    }
  }
  fetchEntries(e) {
    return this.fetchEntity(e);
  }
  constructor({ entities: e, locale: i, sendMessage: s, subscribe: n, timeoutDuration: r = 3e3 }) {
    super({
      entities: e,
      locale: i
    }), C(this, "requestCache", /* @__PURE__ */ new Map()), C(this, "sendMessage", void 0), C(this, "subscribe", void 0), C(this, "timeoutDuration", void 0), C(this, "cacheIdSeperator", ","), this.sendMessage = s, this.subscribe = n, this.timeoutDuration = r;
  }
}
const v = {};
function M(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function Z(t) {
  return v[t] || (v[t] = new je({
    entities: [],
    sendMessage: N,
    subscribe: (e, i) => {
      const s = (n) => {
        typeof n.data != "object" || !n.data || n.data.from === "live-preview" && n.data.method === e && i(n.data);
      };
      return window.addEventListener("message", s), () => window.removeEventListener("message", s);
    },
    locale: t
  })), v[t];
}
async function P({
  entityReferenceMap: t,
  referenceId: e,
  isAsset: i,
  locale: s
}) {
  var o, a, l;
  const n = t.get(e);
  if (n)
    return {
      reference: n,
      typeName: "contentType" in n.sys && ((l = (a = (o = n.sys) == null ? void 0 : o.contentType) == null ? void 0 : a.sys) != null && l.id) ? M(n.sys.contentType.sys.id) : A
    };
  if (i) {
    const c = await Z(s).fetchAsset(e);
    if (!c)
      throw new Error(`Unknown reference ${e}`);
    return {
      reference: c,
      typeName: A
    };
  }
  const r = await Z(s).fetchEntry(e);
  if (!r)
    throw new Error(`Unknown reference ${e}`);
  return {
    reference: r,
    typeName: M(r.sys.contentType.sys.id)
  };
}
function $e(t) {
  return typeof t.data != "object" || !t.data ? !1 : "from" in t.data && t.data.from === "live-preview" || "source" in t.data && t.data.source === ve;
}
var D = /* @__PURE__ */ ((t) => (t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.IFRAME_CONNECTED = "IFRAME_CONNECTED", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t.ENTITY_NOT_KNOWN = "ENTITY_NOT_KNOWN", t.UNKNOWN_REFERENCE_LOADED = "UNKNOWN_REFERENCE_LOADED", t))(D || {});
function oe(t, e, i) {
  N("TAGGED_FIELD_CLICKED", {
    action: "TAGGED_FIELD_CLICKED",
    fieldId: t,
    entryId: e,
    locale: i
  });
}
class Ve {
  constructor({ locale: e }) {
    y(this, "tooltip", null);
    // this tooltip scrolls to the correct field in the entry editor
    y(this, "currentElementBesideTooltip", null);
    // this element helps to position the tooltip
    y(this, "defaultLocale");
    this.tooltip = null, this.currentElementBesideTooltip = null, this.defaultLocale = e, this.updateTooltipPosition = this.updateTooltipPosition.bind(this), this.addTooltipOnHover = this.addTooltipOnHover.bind(this), this.createTooltip = this.createTooltip.bind(this), this.clickHandler = this.clickHandler.bind(this), this.createTooltip(), window.addEventListener("scroll", this.updateTooltipPosition), window.addEventListener("mouseover", this.addTooltipOnHover);
  }
  // Handles incoming messages from Contentful
  receiveMessage(e) {
    ("action" in e && e.action === "INSPECTOR_MODE_CHANGED" || e.method === D.INSPECTOR_MODE_CHANGED) && document.body.classList.toggle(
      "contentful-inspector--active",
      e.isInspectorActive
    );
  }
  // Updates the position of the tooltip
  updateTooltipPosition() {
    var s;
    if (!this.currentElementBesideTooltip || !this.tooltip)
      return !1;
    const e = this.currentElementBesideTooltip.getBoundingClientRect(), i = (s = this.tooltip.parentElement) == null ? void 0 : s.getBoundingClientRect();
    if (e && i) {
      let n = e.top - Ke;
      const r = e.left - Ue;
      return n < 0 && (e.top < 0 ? n = e.top : n = 0), this.tooltip.style.top = n + "px", this.tooltip.style.left = r + "px", !0;
    }
    return !1;
  }
  addTooltipOnHover(e) {
    var s, n, r;
    const i = e.composedPath();
    for (const o of i) {
      const a = o;
      if (a.nodeName === "BODY")
        break;
      if (typeof (a == null ? void 0 : a.getAttribute) != "function")
        continue;
      const l = a.getAttribute(L.FIELD_ID), c = a.getAttribute(L.ENTRY_ID), u = a.getAttribute(L.LOCALE) ?? this.defaultLocale;
      if (l && c && u) {
        this.currentElementBesideTooltip = a, this.updateTooltipPosition() && ((s = this.tooltip) == null || s.setAttribute(q, l), (n = this.tooltip) == null || n.setAttribute(z, c), (r = this.tooltip) == null || r.setAttribute(F, u));
        break;
      }
    }
  }
  createTooltip() {
    if (!document.querySelector(`.${X}`)) {
      const e = document.createElement("button");
      e.classList.add(X), e.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5325 2.22242C13.825 2.51492 13.825 2.98742 13.5325 3.27992L12.16 4.65242L9.3475 1.83992L10.72 0.467422C11.0125 0.174922 11.485 0.174922 11.7775 0.467422L13.5325 2.22242ZM0.25 13.7499V10.9374L8.545 2.64243L11.3575 5.45493L3.0625 13.7499H0.25Z" fill="white"/>
      </svg>Edit`, window.document.body.insertAdjacentElement("beforeend", e), e.addEventListener("click", this.clickHandler), this.tooltip = e;
    }
    this.updateTooltipPosition();
  }
  // responsible for handling the event when the user clicks on the edit button in the tooltip
  clickHandler() {
    var n, r, o;
    const e = (n = this.tooltip) == null ? void 0 : n.getAttribute(q), i = (r = this.tooltip) == null ? void 0 : r.getAttribute(z), s = ((o = this.tooltip) == null ? void 0 : o.getAttribute(F)) || this.defaultLocale;
    e && i && s && oe(e, i, s);
  }
}
var p = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ot(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var S = {}, b = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.BLOCKS = void 0, function(e) {
    e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
  }(t.BLOCKS || (t.BLOCKS = {}));
})(b);
var w = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.INLINES = void 0, function(e) {
    e.HYPERLINK = "hyperlink", e.ENTRY_HYPERLINK = "entry-hyperlink", e.ASSET_HYPERLINK = "asset-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline";
  }(t.INLINES || (t.INLINES = {}));
})(w);
var K = {};
Object.defineProperty(K, "__esModule", { value: !0 });
var m;
(function(t) {
  t.BOLD = "bold", t.ITALIC = "italic", t.UNDERLINE = "underline", t.CODE = "code", t.SUPERSCRIPT = "superscript", t.SUBSCRIPT = "subscript";
})(m || (m = {}));
K.default = m;
var le = {};
(function(t) {
  var e = p && p.__spreadArray || function(a, l, c) {
    if (c || arguments.length === 2)
      for (var u = 0, f = l.length, d; u < f; u++)
        (d || !(u in l)) && (d || (d = Array.prototype.slice.call(l, 0, u)), d[u] = l[u]);
    return a.concat(d || Array.prototype.slice.call(l));
  }, i = p && p.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  }, s;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.V1_MARKS = t.V1_NODE_TYPES = t.TEXT_CONTAINERS = t.HEADINGS = t.CONTAINERS = t.VOID_BLOCKS = t.TABLE_BLOCKS = t.LIST_ITEM_BLOCKS = t.TOP_LEVEL_BLOCKS = void 0;
  var n = b, r = w, o = i(K);
  t.TOP_LEVEL_BLOCKS = [
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE,
    n.BLOCKS.TABLE
  ], t.LIST_ITEM_BLOCKS = [
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE
  ], t.TABLE_BLOCKS = [
    n.BLOCKS.TABLE,
    n.BLOCKS.TABLE_ROW,
    n.BLOCKS.TABLE_CELL,
    n.BLOCKS.TABLE_HEADER_CELL
  ], t.VOID_BLOCKS = [
    n.BLOCKS.HR,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE
  ], t.CONTAINERS = (s = {}, s[n.BLOCKS.OL_LIST] = [n.BLOCKS.LIST_ITEM], s[n.BLOCKS.UL_LIST] = [n.BLOCKS.LIST_ITEM], s[n.BLOCKS.LIST_ITEM] = t.LIST_ITEM_BLOCKS, s[n.BLOCKS.QUOTE] = [n.BLOCKS.PARAGRAPH], s[n.BLOCKS.TABLE] = [n.BLOCKS.TABLE_ROW], s[n.BLOCKS.TABLE_ROW] = [n.BLOCKS.TABLE_CELL, n.BLOCKS.TABLE_HEADER_CELL], s[n.BLOCKS.TABLE_CELL] = [n.BLOCKS.PARAGRAPH], s[n.BLOCKS.TABLE_HEADER_CELL] = [n.BLOCKS.PARAGRAPH], s), t.HEADINGS = [
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6
  ], t.TEXT_CONTAINERS = e([n.BLOCKS.PARAGRAPH], t.HEADINGS, !0), t.V1_NODE_TYPES = [
    n.BLOCKS.DOCUMENT,
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.LIST_ITEM,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    r.INLINES.HYPERLINK,
    r.INLINES.ENTRY_HYPERLINK,
    r.INLINES.ASSET_HYPERLINK,
    r.INLINES.EMBEDDED_ENTRY,
    "text"
  ], t.V1_MARKS = [o.default.BOLD, o.default.CODE, o.default.ITALIC, o.default.UNDERLINE];
})(le);
var ce = {};
Object.defineProperty(ce, "__esModule", { value: !0 });
var ue = {};
Object.defineProperty(ue, "__esModule", { value: !0 });
var Y = {};
Object.defineProperty(Y, "__esModule", { value: !0 });
var x = b, Qe = {
  nodeType: x.BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: x.BLOCKS.PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};
Y.default = Qe;
var O = {};
Object.defineProperty(O, "__esModule", { value: !0 });
O.isText = O.isBlock = O.isInline = void 0;
var We = b, qe = w;
function fe(t, e) {
  for (var i = 0, s = Object.keys(t); i < s.length; i++) {
    var n = s[i];
    if (e === t[n])
      return !0;
  }
  return !1;
}
function ze(t) {
  return fe(qe.INLINES, t.nodeType);
}
O.isInline = ze;
function Fe(t) {
  return fe(We.BLOCKS, t.nodeType);
}
O.isBlock = Fe;
function Xe(t) {
  return t.nodeType === "text";
}
O.isText = Xe;
(function(t) {
  var e = p && p.__createBinding || (Object.create ? function(f, d, E, T) {
    T === void 0 && (T = E);
    var I = Object.getOwnPropertyDescriptor(d, E);
    (!I || ("get" in I ? !d.__esModule : I.writable || I.configurable)) && (I = { enumerable: !0, get: function() {
      return d[E];
    } }), Object.defineProperty(f, T, I);
  } : function(f, d, E, T) {
    T === void 0 && (T = E), f[T] = d[E];
  }), i = p && p.__setModuleDefault || (Object.create ? function(f, d) {
    Object.defineProperty(f, "default", { enumerable: !0, value: d });
  } : function(f, d) {
    f.default = d;
  }), s = p && p.__exportStar || function(f, d) {
    for (var E in f)
      E !== "default" && !Object.prototype.hasOwnProperty.call(d, E) && e(d, f, E);
  }, n = p && p.__importStar || function(f) {
    if (f && f.__esModule)
      return f;
    var d = {};
    if (f != null)
      for (var E in f)
        E !== "default" && Object.prototype.hasOwnProperty.call(f, E) && e(d, f, E);
    return i(d, f), d;
  }, r = p && p.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.helpers = t.EMPTY_DOCUMENT = t.MARKS = t.INLINES = t.BLOCKS = void 0;
  var o = b;
  Object.defineProperty(t, "BLOCKS", { enumerable: !0, get: function() {
    return o.BLOCKS;
  } });
  var a = w;
  Object.defineProperty(t, "INLINES", { enumerable: !0, get: function() {
    return a.INLINES;
  } });
  var l = K;
  Object.defineProperty(t, "MARKS", { enumerable: !0, get: function() {
    return r(l).default;
  } }), s(le, t), s(ce, t), s(ue, t);
  var c = Y;
  Object.defineProperty(t, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
    return r(c).default;
  } });
  var u = n(O);
  t.helpers = u;
})(S);
function ee(t) {
  return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type !== "ResourceLink";
}
function te(t) {
  return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type === "ResourceLink";
}
function j(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = t;
  return e.content && e.nodeType === S.BLOCKS.DOCUMENT;
}
const de = [
  S.BLOCKS.EMBEDDED_ENTRY,
  S.BLOCKS.EMBEDDED_ASSET,
  S.INLINES.EMBEDDED_ENTRY,
  S.INLINES.ENTRY_HYPERLINK,
  S.INLINES.ASSET_HYPERLINK
];
function Ee(t) {
  return t.sys && "linkType" in t.sys && t.sys.linkType === A;
}
const Je = "Collection";
function $(t) {
  return `${t}${Je}`;
}
function he(t, e) {
  var s, n;
  const i = [];
  for (const r of t)
    r.kind === "Field" && (i.push({
      name: r.name.value,
      alias: (s = r.alias) == null ? void 0 : s.value,
      __typename: e
    }), (n = r.selectionSet) != null && n.selections && i.push(
      ...he(r.selectionSet.selections, r.name.value)
    ));
  return i;
}
function Ze(t) {
  var s;
  const e = [];
  for (const n of t.definitions)
    if (n.kind === "OperationDefinition" || n.kind === "FragmentDefinition") {
      const r = "typeCondition" in n ? n.typeCondition.name.value : (s = n.name) == null ? void 0 : s.value;
      if (!r) {
        h.warn("Could not generate __typename for query definition", n);
        continue;
      }
      for (const o of n.selectionSet.selections)
        o.kind === "Field" && e.push(...he(n.selectionSet.selections, r));
    }
  const i = /* @__PURE__ */ new Map();
  for (const { __typename: n, alias: r, name: o } of e) {
    const a = i.get(n) || {
      alias: /* @__PURE__ */ new Map(),
      fields: /* @__PURE__ */ new Set()
    };
    a.fields.add(o), r && a.alias.set(o, r), i.set(n, a);
  }
  return i;
}
function ye(t, e, i) {
  if (!i)
    return !0;
  const s = i.get(e);
  return s ? s.fields.has(t) || s.fields.has($(t)) : !1;
}
function V(t, e, i) {
  var n;
  const s = (n = i == null ? void 0 : i.get(e)) == null ? void 0 : n.alias;
  if (!s)
    return t;
  for (const r in t) {
    const o = s == null ? void 0 : s.get(r);
    o !== r && (t[o] = t[r]);
  }
  return t;
}
function _e(t, e, i) {
  var s, n;
  try {
    const r = e.fields.file, o = r == null ? void 0 : r.details, a = {
      ...t,
      // GraphQL flattens some information
      // and as the live updates are coming from the CMA, we need to transform them
      title: e.fields.title,
      description: e.fields.description,
      contentType: r == null ? void 0 : r.contentType,
      url: He(r == null ? void 0 : r.url),
      // Note: video has no `width` and `height`
      width: (s = o == null ? void 0 : o.image) == null ? void 0 : s.width,
      height: (n = o == null ? void 0 : o.image) == null ? void 0 : n.height
    };
    return V(a, A, i);
  } catch (r) {
    return h.warn("Failed update asset", { dataFromPreviewApp: t, updateFromEntryEditor: e }, r), t;
  }
}
async function xe({
  contentType: t,
  dataFromPreviewApp: e,
  updateFromEntryEditor: i,
  locale: s,
  entityReferenceMap: n,
  gqlParams: r
}) {
  var l;
  if (e.sys.id !== i.sys.id)
    return e;
  const o = k(e), a = M(t.sys.id);
  for (const c of t.fields) {
    const u = c.apiName ?? c.name;
    ye(u, a, r) && (re(c) ? G({
      dataFromPreviewApp: o,
      updateFromEntryEditor: i,
      name: u
    }) : c.type === "RichText" ? await et({
      dataFromPreviewApp: o,
      updateFromEntryEditor: i,
      entityReferenceMap: n,
      name: u,
      locale: s,
      gqlParams: r
    }) : c.type === "Link" ? await Ie({
      dataFromPreviewApp: o,
      updateFromEntryEditor: i,
      name: u,
      locale: s,
      entityReferenceMap: n,
      gqlParams: r
    }) : c.type === "Array" && ((l = c.items) == null ? void 0 : l.type) === "Link" && await Oe({
      dataFromPreviewApp: o,
      updateFromEntryEditor: i,
      name: u,
      locale: s,
      entityReferenceMap: n,
      gqlParams: r
    }));
  }
  return V(o, a, r);
}
function ne(t) {
  return Object.values(t).every((e) => e.length === 0);
}
async function pe(t, e, i, s, n, r) {
  if (de.includes(t.nodeType)) {
    if (t.data && t.data.target && t.data.target.sys) {
      const o = {
        sys: { ...t.data.target.sys, type: "Link", linkType: t.data.target.sys.type }
      };
      let a;
      if (t.data.target.sys.linkType === "Entry" ? a = await De({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: s,
        locale: n,
        gqlParams: r
      }) : t.data.target.sys.linkType === "Asset" && (a = await Le({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: s,
        locale: n,
        gqlParams: r
      })), a)
        switch (t.nodeType) {
          case S.BLOCKS.EMBEDDED_ENTRY:
            e.block.push(a);
            break;
          case S.BLOCKS.EMBEDDED_ASSET:
            i.block.push(a);
            break;
          case S.INLINES.EMBEDDED_ENTRY:
            e.inline.push(a);
            break;
          case S.INLINES.ENTRY_HYPERLINK:
            e.hyperlink.push(a);
            break;
          case S.INLINES.ASSET_HYPERLINK:
            i.hyperlink.push(a);
            break;
          default:
            h.warn("Unhandled nodeType in embedded entries in rich text", {
              nodeType: t.nodeType,
              ref: a
            });
        }
    }
  } else if (t.content)
    for (const o of t.content)
      await pe(o, e, i, s, n, r);
}
async function Te(t, e, i, s) {
  const n = { block: [], inline: [], hyperlink: [] }, r = { block: [], inline: [], hyperlink: [] };
  if (t)
    for (const o of t.content)
      await pe(o, n, r, e, i, s);
  return {
    entries: ne(n) ? { block: [], inline: [], hyperlink: [] } : n,
    assets: ne(r) ? { block: [], inline: [], hyperlink: [] } : r
  };
}
async function et({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: i,
  locale: s,
  entityReferenceMap: n,
  gqlParams: r
}) {
  var o;
  t[i] || (t[i] = {}), t[i].json = ((o = e == null ? void 0 : e.fields) == null ? void 0 : o[i]) || null, t[i].links = await Te(
    t[i].json,
    n,
    s,
    r
  );
}
async function Le({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: i,
  locale: s,
  gqlParams: n
}) {
  const { reference: r } = await P({
    entityReferenceMap: i,
    referenceId: e.sys.id,
    isAsset: !0,
    locale: s
  });
  return _e(
    {
      ...t,
      ...e,
      __typename: A
    },
    r,
    n
  );
}
async function De({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: i,
  locale: s,
  gqlParams: n
}) {
  var l;
  const { reference: r, typeName: o } = await P({
    entityReferenceMap: i,
    referenceId: e.sys.id,
    locale: s
  }), a = {
    ...t,
    ...e,
    __typename: o
  };
  for (const c in r.fields) {
    if (!ye(c, o, n))
      continue;
    const u = r.fields[c];
    if (u && typeof u == "object")
      j(u) && (a[c] = { json: u }, a[c].links = await Te(u, i, s)), "sys" in u && (a[c] = u, await Ie({
        dataFromPreviewApp: a,
        updateFromEntryEditor: r,
        locale: s,
        entityReferenceMap: i,
        name: c,
        gqlParams: n
      }));
    else if (Array.isArray(u) && ((l = u[0]) != null && l.sys)) {
      const f = $(c);
      a[f] = { items: u }, await Oe({
        dataFromPreviewApp: a,
        updateFromEntryEditor: r,
        locale: s,
        entityReferenceMap: i,
        name: c,
        gqlParams: n
      });
    } else
      a[c] = u;
  }
  return V(a, o, n);
}
async function Se({
  referenceFromPreviewApp: t,
  updatedReference: e,
  entityReferenceMap: i,
  locale: s,
  gqlParams: n
}) {
  return e ? t && t.__typename ? t : e.__typename ? e : Ee(e) ? Le({
    referenceFromPreviewApp: t,
    updatedReference: e,
    entityReferenceMap: i,
    locale: s,
    gqlParams: n
  }) : De({
    referenceFromPreviewApp: t,
    updatedReference: e,
    entityReferenceMap: i,
    locale: s,
    gqlParams: n
  }) : null;
}
async function Ie({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: i,
  locale: s,
  entityReferenceMap: n,
  gqlParams: r
}) {
  var a;
  const o = (a = e == null ? void 0 : e.fields) == null ? void 0 : a[i];
  t[i] = await Se({
    referenceFromPreviewApp: t[i],
    updatedReference: o,
    entityReferenceMap: n,
    locale: s,
    gqlParams: r
  });
}
async function Oe({
  dataFromPreviewApp: t,
  updateFromEntryEditor: e,
  name: i,
  locale: s,
  entityReferenceMap: n,
  gqlParams: r
}) {
  var c;
  const o = $(i), a = ((c = e == null ? void 0 : e.fields) == null ? void 0 : c[i]) || [], l = await Promise.all(
    a.map(async (u) => {
      var E, T;
      const f = (T = (E = t[o]) == null ? void 0 : E.items) == null ? void 0 : T.find((I) => I.sys.id === u.sys.id);
      return await Se({
        referenceFromPreviewApp: f,
        updatedReference: u,
        entityReferenceMap: n,
        locale: s,
        gqlParams: r
      });
    })
  );
  t[o] || (t[o] = { items: [] }), t[o].items = l.filter(Boolean);
}
function H(t) {
  if (Array.isArray(t)) {
    for (const e of t) {
      const i = H(e);
      if (Object.values(i).includes(!0))
        return i;
    }
    return { isGQL: !1, sysId: null, isREST: !1 };
  } else {
    const e = Object.hasOwn(t, "__typename"), i = Object.hasOwn(t, "sys") ? t.sys.id : null, s = Object.hasOwn(t, "fields");
    return e || i || s ? { isGQL: e, sysId: i, isREST: s } : H(Object.values(t));
  }
}
function tt(t) {
  let e = !0;
  const { isGQL: i, sysId: s, isREST: n } = H(t);
  return s || (e = !1, h.error('Live Updates requires the "sys.id" to be present on the provided data', t)), !i && !n && (e = !1, h.error(
    'For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.',
    t
  )), {
    isGQL: i,
    isREST: n,
    sysId: s,
    isValid: e
  };
}
function nt(t, e) {
  return t.name === "Asset" ? e.id : e.apiName || e.name;
}
async function Q(t, e, i, s, n, r) {
  let o;
  if (r.has(e.sys.id))
    h.warn("Detected a circular reference, stopping recursion"), o = s.get(
      "urn" in e.sys ? e.sys.urn : e.sys.id
    );
  else {
    r.add(
      "urn" in e.sys ? e.sys.urn : e.sys.id
    );
    const { reference: l } = await P({
      entityReferenceMap: s,
      referenceId: e.sys.id,
      ...Ee(e) ? { isAsset: !0 } : void 0,
      locale: i
    });
    o = l;
  }
  if (!o)
    return t;
  const a = k(o);
  for (const l in o.fields) {
    const c = o.fields[l];
    if (ee(c) && n < g)
      await Ce(
        a,
        o,
        i,
        l,
        s,
        n + 1,
        r
      );
    else if (Array.isArray(c) && ee(c[0]) && n < g)
      await Ne(
        a,
        o,
        i,
        l,
        s,
        n + 1,
        r
      );
    else if (j(c))
      await be(
        a,
        o,
        l,
        i,
        s,
        n + 1,
        r
      );
    else {
      if (te(c) || Array.isArray(c) && te(c[0]))
        return h.warn("Detected a resource link, support is still under development."), a;
      G({
        dataFromPreviewApp: a.fields,
        updateFromEntryEditor: o,
        name: l
      });
    }
  }
  return a;
}
async function Ne(t, e, i, s, n, r, o) {
  var a;
  if (!((a = e.fields) != null && a[s])) {
    delete t.fields[s];
    return;
  }
  return t.fields[s] = await Promise.all(
    e.fields[s].map(
      (l, c) => {
        var u;
        return Q(
          (u = t.fields[s]) == null ? void 0 : u[c],
          l,
          i,
          n,
          r + 1,
          o
        );
      }
    )
  ).then((l) => l.filter(Boolean)), t;
}
async function Ce(t, e, i, s, n, r, o) {
  var l;
  const a = (l = e == null ? void 0 : e.fields) == null ? void 0 : l[s];
  if (!a) {
    delete t.fields[s];
    return;
  }
  return t.fields[s] = await Q(
    t.fields[s],
    a,
    i,
    n,
    r + 1,
    o
  ), t;
}
async function Ae(t, e, i, s, n) {
  var r;
  if (de.includes(t.nodeType) && t.data && t.data.target && t.data.target.sys && (t.data.target.sys.linkType === "Entry" || t.data.target.sys.linkType === "Asset")) {
    const a = {
      sys: { id: ((r = t.data.target) == null ? void 0 : r.sys.id) || "", type: "Link", linkType: t.data.target.sys.linkType }
    };
    t.data.target = await Q(
      void 0,
      a,
      i,
      e,
      s + 1,
      n
    );
  }
  if (t.content)
    for (const o of t.content)
      await Ae(
        o,
        e,
        i,
        s + 1,
        n
      );
}
async function be(t, e, i, s, n, r, o) {
  var l;
  const a = (l = e.fields) == null ? void 0 : l[i];
  if (j(a)) {
    t.fields[i] = a;
    for (const c of a.content)
      await Ae(c, n, s, r, o);
  }
}
async function it(t, e, i, s, n, r, o) {
  var a;
  if (e.sys.id !== i.sys.id)
    return e;
  for (const l of t.fields) {
    const c = nt(t, l);
    if (re(l) || l.type === "File")
      G({
        dataFromPreviewApp: e.fields,
        updateFromEntryEditor: i,
        name: c
      });
    else if (l.type === "Link" && r < g)
      await Ce(
        e,
        i,
        s,
        c,
        n,
        r + 1,
        o
      );
    else if (l.type === "Array" && ((a = l.items) == null ? void 0 : a.type) === "Link" && r < g)
      await Ne(
        e,
        i,
        s,
        c,
        n,
        r + 1,
        o
      );
    else if (l.type === "RichText")
      await be(
        e,
        i,
        c,
        s,
        n,
        r,
        o
      );
    else if (l.type === "ResourceLink")
      return h.warn("Detected a resource link, support is still under development."), e;
  }
  return e;
}
class st {
  constructor({ locale: e }) {
    y(this, "subscriptions", /* @__PURE__ */ new Map());
    y(this, "storage");
    y(this, "defaultLocale");
    this.defaultLocale = e, this.storage = new me("live-updates", /* @__PURE__ */ new Map()), window.addEventListener("beforeunload", () => this.clearStorage());
  }
  async mergeEntity({
    contentType: e,
    dataFromPreviewApp: i,
    entityReferenceMap: s,
    locale: n,
    updateFromEntryEditor: r,
    gqlParams: o,
    visitedReferences: a
  }) {
    return "__typename" in i ? {
      data: await (i.__typename === "Asset" ? _e(i, r, o) : xe({
        contentType: e,
        dataFromPreviewApp: i,
        updateFromEntryEditor: r,
        locale: n,
        entityReferenceMap: s,
        gqlParams: o
      })),
      updated: !0
    } : this.isCfEntity(i) ? {
      data: await it(
        e,
        i,
        r,
        n,
        s,
        0,
        a
      ),
      updated: !0
    } : { updated: !1, data: i };
  }
  /**
   * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
   * If there is not direct match, it will try to merge things together recursively
   * caches the result if cache is enabled and the entity has a `sys.id`.
   * Caching should not be enabled for every entry,
   * because nested references could be merged differently together and this could solve to data loss.
   */
  async mergeNestedReference({ dataFromPreviewApp: e, ...i }, s) {
    const n = B(e) && e.sys.id, r = s && n;
    let o = !1, a = (r ? this.storage.get(n, i.locale) : void 0) || e;
    if (B(a) && n === i.updateFromEntryEditor.sys.id) {
      const l = await this.mergeEntity({ ...i, dataFromPreviewApp: a });
      a = l.data, o = l.updated;
    } else
      for (const l in a)
        if (a[l] && typeof a[l] == "object") {
          const c = await this.merge(
            { ...i, dataFromPreviewApp: a[l] },
            !1
          );
          a[l] = c.data, o = o || c.updated;
        }
    return r && this.storage.set(n, i.locale, a), { data: a, updated: o };
  }
  async merge({ dataFromPreviewApp: e, ...i }, s = !0) {
    if (Array.isArray(e)) {
      const n = [];
      let r = !1;
      for (const o of e) {
        const a = await this.mergeNestedReference(
          { ...i, dataFromPreviewApp: o },
          s
        );
        n.push(a.data), r = r || a.updated;
      }
      return { data: n, updated: r };
    }
    return this.mergeNestedReference({ ...i, dataFromPreviewApp: e }, s);
  }
  isCfEntity(e) {
    return B(e) && "fields" in e;
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(e) {
    if ("action" in e && e.action === "ENTRY_UPDATED" || e.method === D.ENTRY_UPDATED) {
      const { entity: i, contentType: s, entityReferenceMap: n } = e;
      await Promise.all(
        [...this.subscriptions].map(async ([, r]) => {
          try {
            const o = /* @__PURE__ */ new Set(), { updated: a, data: l } = await this.merge({
              // Clone the original data on the top level,
              // to prevent cloning multiple times (time)
              // or modifying the original data (failure potential)
              dataFromPreviewApp: k(r.data),
              locale: r.locale || this.defaultLocale,
              updateFromEntryEditor: i,
              contentType: s,
              entityReferenceMap: n,
              gqlParams: r.gqlParams,
              visitedReferences: o
            });
            a && r.callback(l);
          } catch (o) {
            N(D.ERROR, {
              message: o.message,
              payload: { data: r.data, update: i },
              type: "SUBSCRIPTION_UPDATE_FAILED"
            }), h.error("Failed to apply live update", {
              error: o,
              subscribedData: r.data,
              updateFromEditor: i
            });
          }
        })
      );
    }
  }
  async restore(e, i, s) {
    if (!e)
      return;
    const n = (a) => {
      if (B(a)) {
        const l = this.storage.get(a.sys.id, i);
        if (l)
          return l;
      }
      return a;
    };
    let r;
    if (Array.isArray(e))
      r = e.map(n);
    else {
      const a = n(e);
      a !== e && (r = a);
    }
    const o = this.subscriptions.get(s);
    o && r && o.callback(r);
  }
  clearStorage() {
    this.storage.clear();
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(e) {
    const { isGQL: i, isValid: s, sysId: n, isREST: r } = tt(e.data);
    if (!s)
      return N(D.ERROR, {
        message: "Failed to subscribe",
        payload: { isGQL: i, isValid: s, sysId: n, isREST: r },
        type: "SUBSCRIPTION_SETUP_FAILED"
      }), () => {
      };
    const o = ke(), a = e.locale || this.defaultLocale;
    return this.subscriptions.set(o, {
      ...e,
      gqlParams: e.query ? Ze(e.query) : void 0
    }), setTimeout(() => {
      this.restore(e.data, a, o);
    }, 0), N(D.SUBSCRIBED, {
      action: D.SUBSCRIBED,
      type: i ? "GQL" : "REST",
      locale: a,
      entryId: n
    }), () => {
      this.subscriptions.delete(o);
    };
  }
}
const _ = class _ {
  // Static method to initialize the LivePreview SDK
  static init(e) {
    if (typeof e != "object" || !(e != null && e.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const { debugMode: i, enableInspectorMode: s, enableLiveUpdates: n, locale: r } = e;
    if (typeof window < "u") {
      if (!Ge())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (i && W(i), typeof s == "boolean" && (this.inspectorModeEnabled = s), typeof n == "boolean" && (this.liveUpdatesEnabled = n), this.locale = r, _.initialized)
        return h.log("You have already initialized the Live Preview SDK."), Promise.resolve(_.inspectorMode);
      this.inspectorModeEnabled && (_.inspectorMode = new Ve({ locale: r })), this.liveUpdatesEnabled && (_.liveUpdates = new st({ locale: r })), window.addEventListener("message", (a) => {
        var l, c;
        if ($e(a)) {
          if (h.log("Received message", a.data), "action" in a.data && a.data.action === "DEBUG_MODE_ENABLED" || a.data.method === D.DEBUG_MODE_ENABLED) {
            W(!0);
            return;
          }
          this.inspectorModeEnabled && ((l = _.inspectorMode) == null || l.receiveMessage(a.data)), this.liveUpdatesEnabled && ((c = _.liveUpdates) == null || c.receiveMessage(a.data));
        }
      }), Pe(() => {
        N(D.URL_CHANGED, {
          action: D.URL_CHANGED,
          taggedElementCount: document.querySelectorAll(`[${L.ENTRY_ID}]`).length
        });
      });
      const o = document.querySelectorAll(`[${L.ENTRY_ID}]`).length;
      return N(D.CONNECTED, {
        action: D.CONNECTED,
        connected: !0,
        tags: o,
        taggedElementCount: o,
        locale: this.locale,
        isInspectorEnabled: this.inspectorModeEnabled,
        isLiveUpdatesEnabled: this.liveUpdatesEnabled
      }), this.initialized = !0, Promise.resolve(_.inspectorMode);
    }
  }
  static subscribe(e) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    if (!this.liveUpdates)
      throw new Error(
        "Live Updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(e);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps({ fieldId: e, entryId: i, locale: s }) {
    return this.inspectorModeEnabled ? !e || !i ? (h.warn("Missing property for inspector mode", { fieldId: e, entryId: i }), null) : {
      [L.FIELD_ID]: e,
      [L.ENTRY_ID]: i,
      [L.LOCALE]: s
    } : null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  static openEntryInEditor({ fieldId: e, entryId: i, locale: s }) {
    (!e || !i) && h.error("Please provide field id and entry id to openEntryInEditor."), oe(e, i, s || this.locale);
  }
};
y(_, "initialized", !1), y(_, "inspectorMode", null), y(_, "liveUpdates", null), y(_, "inspectorModeEnabled", !0), y(_, "liveUpdatesEnabled", !0), y(_, "locale");
let ie = _;
export {
  ie as C,
  ve as L,
  R as P,
  Me as a,
  D as b,
  p as c,
  at as d,
  ot as g,
  oe as o
};
//# sourceMappingURL=index-9945b172.js.map
